import React, { useState, useEffect } from "react";
import { useStateValue } from "../../context/store";
import { getValidateCvByDocumentAndType } from "../../actions/cv-actions";
import { useRouteMatch } from "react-router-dom";
import { getById } from "../../actions/user-actions";
import { withRouter } from "react-router";
import Utils from "../../utils/utils";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

function Curriculum(props) {
  const [{ sessionUser }, dispatch] = useStateValue();
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    type: "",
    title: "",
  });
  const closeMessage = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };
  const { path } = useRouteMatch();

  const getCurriculum = (data) => {
    const getCv = async () => {
      const cvResponse = await getValidateCvByDocumentAndType(
        data.documentNumber,
        data.documentType,
        dispatch
      );
      let type = Utils.encrypt(data.documentType);
      let document = Utils.encrypt(data.documentNumber);
      const cv = cvResponse.data;
      if (cv) {
        props.history.push(`${path}/editar`);
      } else {
        props.history.push(`${path}/crear`);
      }
    };
    getCv();
  };

  useEffect(() => {
    const getPerson = async () => {
      const data = JSON.parse(localStorage.getItem("state"));
      let personId = sessionUser && sessionUser.userInfo.person.id;
      let id = personId ? personId : data.userInfo.person.id;
      const personResponse = await getById(id, dispatch);
      const person = personResponse.data;
      if (person) {
        getCurriculum(person);
      }
    };

    getPerson();
  }, []);

  return (
    <>
      <ModalConfirmBase
        description={confirm.question}
        open={confirm.open}
        handleClick={confirm.handleClick}
        handleClickOut={confirm.handleClickOut}
        type={confirm.type}
        title={confirm.title}
      />
    </>
  );
}

export default withRouter(Curriculum);
